export function getObjectKeys<T extends object>(object: T): (keyof T)[] {
  // TypeScript's Object.keys returns string[], which is not type-safe.
  // This function provides a type-safe alternative.
  return Object.keys(object) as (keyof T)[];
}

export function hasOwnKey<TObject extends object>(
  object: TObject,
  key?: PropertyKey
): key is keyof TObject {
  if (key === undefined) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(object, key);
}
